import React, {Component} from 'react';
import {
    Col,
    Card,
    CardBody,
    CardHeader,
} from "reactstrap";
import {api_base_url} from "../../../settings";
import Deserialiser from 'deserialise-jsonapi'
import Loading from '../../dumb/loading'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import filterFactory, {
    textFilter,
} from 'react-bootstrap-table2-filter';

import ExportCSVButton from '../../dumb/fancyTable/ExportCSVButton'
import ExportXLSXButton from '../../dumb/fancyTable/ExportXLSXButton'
import {paginationOptions} from '../../dumb/fancyTable/Pagination'
import ColumnHeader from "../../dumb/fancyTable/columnHeader";

const des = new Deserialiser();

class ModelProteomics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeColumns: 5,
            model: props.model
        };

        this.wideBoxThreshold = 5;

        this.loadProteomics = this.loadProteomics.bind(this);
        this.renderTable = this.renderTable.bind(this);
        this.onColumnToggleHandler = this.onColumnToggleHandler.bind(this);
    }


    onColumnToggleHandler(activeColumns) {
        this.setState({activeColumns});
    }

    loadProteomics() {
        const model_id = this.state.model.id;

        const url = `${api_base_url}/models/${model_id}/datasets/proteomics?include=gene&page[size]=0&fields[gene]=symbol,hgnc_status&sort=-zscore&filter=[{"name": "protein_intensity", "op": "ne", "val": null},{"name":"gene","op":"has","val":{"name":"hgnc_status","op":"eq","val":"current"}}]`;

        fetch(url)
            .then(response => response.json())
            .then(resp_obj => des.deserialise(resp_obj))
            .then(proteomics => {
                    this.setState({
                        proteomics: proteomics,
                        load_complete: 1
                    })
                }
            ).catch((ex) => {
            console.log('parsing failed', ex);
        });
    }

    renderTable() {

        const columns = [
            {
                dataField: 'uniprot_id',
                text: "Uniprot ID",
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                tooltipText: "Uniprot ID"
            },
            {
                dataField: 'gene.symbol',
                text: "Symbol",
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                tooltipText: "Gene Symbol"
            }, {
                dataField: 'protein_intensity',
                text: "Protein Intensity",
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                tooltipText: "Protein Intensity"
            }, {
                dataField: 'zscore',
                text: "Z-Score",
                filter: textFilter({placeholder: ' '}),
                headerFormatter: (column, colIndex, {sortElement, filterElement}) =>
                        <ColumnHeader column={column} colIndex={colIndex} sortElement={sortElement} filterElement={filterElement} />,
                tooltipText: "Z-Score"
            }
        ];

        return (

            <ToolkitProvider
                keyField="id"
                data={this.state.proteomics}
                columns={columns}
                exportCSV={{fileName: `CMP_${this.state.model.names[0]}_proteomics.csv`}}
            >
                {
                    props => (
                        <div>
                            <div className="d-flex justify-content-left">
                                Relative protein intensities across cell lines. Not suitable for comparisons between proteins within a single cell line.
                            </div>
                            <div className="d-flex justify-content-end">
                                <ExportCSVButton {...props.csvProps} />
                                <ExportXLSXButton data={this.state.proteomics} filename={`CMP_${this.state.model.names[0]}_proteomics`} />
                            </div>
                            <BootstrapTable
                                {...props.baseProps}
                                bootstrap4
                                hover
                                keyField='id'
                                bordered={false}
                                pagination={this.state.proteomics.length > 5 ? paginationFactory(paginationOptions(5, this.state.proteomics.length)) : null}
                                filter={filterFactory()}
                                tableHeaderClass="border-top-none"
                            />
                        </div>
                    )
                }
            </ToolkitProvider>


        )
    }

    componentDidMount() {
        this.loadProteomics()
    }

    componentDidUpdate() {
        if (this.props.model.id !== this.state.model.id) {
            this.setState({model: this.props.model, load_complete: false}, this.loadProteomics)

        }
    }

    render() {
        if (!this.state.model.proteomics_available) return null;

        let content = null;


        if (!this.state.load_complete) {
            content = (
                <div className="py-5"><Loading subtitle="Loading Proteomics"/></div>);
        } else {
            content = this.renderTable()
        }
        return (
            <Col className="my-3" lg={(this.state.activeColumns > this.wideBoxThreshold) ? 12 : 6}
                 xl={(this.state.activeColumns > this.wideBoxThreshold) ? 12 : 6}>
                <Card className="flex-fill models fusions">
                    <CardHeader>Proteomics</CardHeader>
                    <CardBody>
                        {content}
                    </CardBody>
                </Card>
            </Col>
        );
    }
}

export default ModelProteomics;
